import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentProduct: null,
  sellerAddress: null,
  loading: false,
  error: null,
  likedProducts: [],
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setCurrentProduct: (state, action) => {
      state.currentProduct = action.payload;
      
      if (action.payload) {
        console.log('[PRODUCT] Setting current product:', action.payload.id, action.payload.name);
        
        // Log product shipping info
        console.log('[PRODUCT] Product shipping enabled:', action.payload.openToShipping);
        console.log('[PRODUCT] Product shipping address:', action.payload.shippingAddress);
        
        // Log product pickup info
        console.log('[PRODUCT] Product pickup enabled:', action.payload.openToPickUp);
        console.log('[PRODUCT] Product pickup address:', action.payload.pickupAddress);
        console.log('[PRODUCT] Product useShippingForPickup:', action.payload.useShippingForPickup);
        
        const shippingAddress = action.payload.shippingAddress;
        
        let sellerAddress = null;
        
        if (action.payload.openToShipping && shippingAddress) {
          sellerAddress = shippingAddress;
          console.log('[PRODUCT] Using shipping address as seller address');
        } else if (action.payload.openToPickUp) {
          if (action.payload.useShippingForPickup && shippingAddress) {
            sellerAddress = shippingAddress;
            console.log('[PRODUCT] Using shipping address for pickup (useShippingForPickup=true)');
          } else if (action.payload.pickupAddress) {
            sellerAddress = action.payload.pickupAddress;
            console.log('[PRODUCT] Using dedicated pickup address');
          }
        }
        
        state.sellerAddress = sellerAddress;
        
        console.log('[PRODUCT] Final seller address:', sellerAddress);
      }
      
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    toggleLikeProduct: (state, action) => {
      const productId = action.payload;
      const index = state.likedProducts.indexOf(productId);
      if (index === -1) {
        state.likedProducts.push(productId);
      } else {
        state.likedProducts.splice(index, 1);
      }
    },
    setLikedProducts: (state, action) => {
      state.likedProducts = action.payload;
    },
  },
});

export const {
  setCurrentProduct,
  setLoading,
  setError,
  toggleLikeProduct,
  setLikedProducts,
} = productSlice.actions;

// Selectors
export const selectCurrentProduct = (state) => state.product.currentProduct;
export const selectProductLoading = (state) => state.product.loading;
export const selectProductError = (state) => state.product.error;
export const selectLikedProducts = (state) => state.product.likedProducts;
export const selectIsProductLiked = (state, productId) => 
  state.product.likedProducts.includes(productId);

export const selectSellerAddress = (state) => state.product.sellerAddress;
export const selectSellerCoordinates = (state) => {
  const address = state.product.sellerAddress;
  if (address && address.latitude && address.longitude) {
    return {
      latitude: address.latitude,
      longitude: address.longitude,
      country: address.country
    };
  }
  return null;
};

export default productSlice.reducer;
